import { Grid2 as Grid } from '@mui/material';
import { withStyles } from '@mui/styles';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { COLORS } from '../../../utils/Application_Constants';

const styles = () => ({
    container: {
        background: 'none',
        border: 'none',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        color: COLORS.LT_MIDNIGHT75,
        padding: '12px 0px',
    },
    justifyBetween: {
        justifyContent: 'space-between',
    },
    paragraph3: {
        display: 'block',
        fontSize: '12px',
        lineHeight: '18px',
        '& span:hover': {
            cursor: 'pointer',
        },
        maxWidth: '100%',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        textWrap: 'nowrap',
        marginBottom: 0,
        textAlign: 'left',
        fontWeight: 600,
    },
    headerCell: {
        padding: '0 16px',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: COLORS.LT_MIDNIGHTBG1,
        flexShrink: 0,
        flexGrow: 1,
        '&:first-child': {
            paddingLeft: '24px',
            borderRadius: '8px 0 0 8px',
        },
        '&:last-child': {
            paddingRight: '24px',
            justifyContent: 'flex-end',
            borderRadius: '0 8px 8px 0',
        },
    },
    sorted: {
        '& p': {
            fontWeight: 700,
        },
    },
    xs: {
        maxWidth: '6.166666%',
        flexBasis: '6.166666%',
    },
    sortIcon: {
        transition: '.15s',
        '&.desc': {
            transform: 'rotate(180deg)',
        },
    },
    sortIcons: {
        color: COLORS.LT_MIDNIGHT50,
        '& $sortIcon': {
            margin: '-5px 0',
        },
    },
    sortable: {
        '& *': {
            cursor: 'pointer',
        },
    },
    leftIconLeftMargin: {
        marginLeft: '10px',
    },
});

function ListViewHeaderCell({
    classes,
    sorted = false,
    size = 1,
    sortKey = '',
    name = '',
    sortDirection = 'asc',
    onSort,
    sortIconPosition = 'right',
    sx = {},
    title,
}) {
    const Tag = sortKey ? 'button' : 'div';

    return (
        <Grid
            size={size}
            key={name}
            className={[
                classes.headerCell,
                size === 0.5 && classes.xs,
                sorted && classes.sorted,
                sortKey !== '' && classes.sortable,
            ].join(' ')}
            sx={sx}
        >
            <Tag
                className={[
                    classes.container,
                    sortIconPosition === 'right' && classes.justifyBetween,
                ].join(' ')}
                title={title || name}
                onClick={sortKey ? () => onSort(sortKey) : () => {}}
            >
                <p className={classes.paragraph3}>{sortKey !== '' ? <span>{name}</span> : name}</p>
                <div
                    className={[
                        classes.sortIcons,
                        sortIconPosition === 'left' ? classes.leftIconLeftMargin : '',
                    ].join(' ')}
                >
                    {sorted && (
                        <ArrowDropUpIcon
                            className={[classes.sortIcon, sortDirection].join(' ')}
                            fontSize="small"
                        />
                    )}
                    {!sorted && sortKey !== '' && (
                        <Grid container direction="column" className={classes.sortIcons}>
                            <ArrowDropUpIcon
                                className={`${classes.sortIcon} asc`}
                                fontSize="small"
                            />
                            <ArrowDropUpIcon
                                className={`${classes.sortIcon} desc`}
                                fontSize="small"
                            />
                        </Grid>
                    )}
                </div>
            </Tag>
        </Grid>
    );
}

export default withStyles(styles)(ListViewHeaderCell);
